import React, { useEffect, useState } from "react";
import { Spin } from "antd";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { LoadingOutlined } from "@ant-design/icons";
import { CancelIcon, CategoryIcon, CheckOutIcon } from "svgIcon";
import {
  BasicTheme,
  EcommerceFlow,
  ExclusiveFlow,
  ExclusiveTheme,
  StandardTheme,
  SuiFrensFlow,
  SuiFrensTheme,
  toastMessage,
  useGlobalMerchant
} from "utils/helper";
import { getMerchantCategory, getMerchantProduct } from "apiServices/app";
import CategoryComponent from "components/Product/CategoryComponent";
import ProductListComponent from "components/Product/ProductListComponent";

const ECProductComponent = () => {
  const { ecommerceContent, isEndsWithSlash, themeName, globalMerchantId } = useGlobalMerchant();
  const [showLoader, setShowLoader] = useState(false);
  const [showSideCategories, setShowSideCategories] = useState(false);
  const [showSideBasket, setShowSideBasket] = useState(false);
  const [newOne, setNewOne] = useState(0);
  const [catClick, setCatClick] = useState({
    category_id: 99001,
    category_name: "All",
    image_path: null,
  });
  const [productList, setProductList] = useState<any>([]);
  const [categoryList, setCategoryList] = useState<any>([]);

  const onMerchantCategory = () => {
    setShowLoader(true);
    try {
      getMerchantCategory(globalMerchantId)
        .then((response) => {
          const responseData = response.data || response;
          if (responseData !== null && responseData.success !== false) {
            if (responseData.length === 0) {
              setShowLoader(false);
              toastMessage("OOPS you dont have any category");
            } else {
              setCategoryList([
                {
                  category_id: 99001,
                  category_name: "All",
                  image_path: null,
                },
                ...responseData,
              ]);
              setNewOne(1);
              getMerchantProducts();
            }
          }
        })
        .catch((error) => {
          setShowLoader(false);
          toastMessage(error);
        });
    } catch (error: any) { }
  };

  const getMerchantProducts = () => {
    try {
      getMerchantProduct(globalMerchantId)
        .then((response) => {
          const responseData = response.data || response;
          if (responseData !== null && responseData.success !== false) {
            if (responseData.length === 0) {
              setShowLoader(false);
              toastMessage("OOPS you dont have any product");
            } else {
              setProductList(responseData);
              setShowLoader(false);
            }
          }
        })
        .catch((error) => {
          setShowLoader(false);
          toastMessage(error);
        });
    } catch (error: any) { }
  };

  const FrensContent = () => (
    <div className="productSection">
      {!isEndsWithSlash && (
        <div className="pHeader dFlex alignCenter justifyBetween">
          <div className="left">
            <h2 className="pHeading sLgText textUpper">{ecommerceContent.shop_title}</h2>
            <p className="pText sNmText"> {ecommerceContent.shop_des}</p>
          </div>
          <div className="right dFlex justifyCenter alignCenter gap10">
            <CategoryComponent
              viewName={SuiFrensFlow}
              categoryList={categoryList}
              setCatClick={setCatClick}
              catClick={catClick}
              showSideCategories={showSideCategories}
              setNewOne={setNewOne}
            />
          </div>
        </div>
      )}
      <div className="pBody">
        <ProductListComponent
          viewName={SuiFrensFlow}
          setCatClick={setCatClick}
          productList={productList}
          catClick={catClick}
          setNewOne={setNewOne}
          newOne={newOne}
        />
      </div>
    </div>
  )

  const ExclusiveContent = () => (
    <div className="productSection">
      <div className="pHeader dFlex alignCenter justifyBetween">
        <div className="left">
          <h2 className="pHeading">{ecommerceContent.shop_title}</h2>
          <p className="pText"> {ecommerceContent.shop_des}</p>
        </div>
        <div className="right dFlex justifyCenter alignCenter gap10">
          <CategoryComponent
            viewName={ExclusiveFlow}
            categoryList={categoryList}
            setCatClick={setCatClick}
            catClick={catClick}
            showSideCategories={showSideCategories}
            setNewOne={setNewOne}
          />
        </div>
      </div>
      <div className="pBody">
        <ProductListComponent
          viewName={ExclusiveFlow}
          setCatClick={setCatClick}
          productList={productList}
          catClick={catClick}
          setNewOne={setNewOne}
          newOne={newOne}
        />
      </div>
    </div>
  )

  const EcommerceContent = () => (
    <main className="productWrapper">
      <div className="productHeader">
        <div className="left" onClick={() => { setShowSideCategories(!showSideCategories); setShowSideBasket(false); }}>
          {showSideCategories ? <CancelIcon /> : <CategoryIcon />}
          <span className="mainHeadingPara">Categories</span>
        </div>
        <div onClick={() => { setShowSideBasket(!showSideBasket); setShowSideCategories(false); }}> {showSideBasket ? <CancelIcon /> : <CheckOutIcon />} </div>
      </div>
      {productList.length > 0 && (
        <>
          <CategoryComponent
            viewName={EcommerceFlow}
            categoryList={categoryList}
            setCatClick={setCatClick}
            catClick={catClick}
            showSideCategories={showSideCategories}
            setNewOne={setNewOne}
          />
          <div className="productPage">
            {Object.keys(ecommerceContent).length > 0 && (
              <div className="productHeadingWrapper">
                <p className="mainHeading">{ecommerceContent.shop_title}</p>
                <p className="mainHeadingPara"> {ecommerceContent.shop_des}</p>
              </div>
            )}
            <ProductListComponent
              viewName={EcommerceFlow}
              setCatClick={setCatClick}
              productList={productList}
              catClick={catClick}
              setNewOne={setNewOne}
              newOne={newOne}
            />
          </div>
        </>
      )}
    </main>
  )

  const renderMainContent = (getThemeName: any) => {
    switch (getThemeName) {
      case SuiFrensTheme: return <FrensContent />;
      case ExclusiveTheme: return <ExclusiveContent />;
      case StandardTheme: return <EcommerceContent />;
      case BasicTheme: return <EcommerceContent />;
      default: return <EcommerceContent />;
    }
  };

  useEffect(() => {
    !!globalMerchantId ? onMerchantCategory() : toastMessage("globalMerchantId not getting");
  }, []);

  return (
    <>
      <ToastContainer />
      {showLoader ? (
        <div className="loaderCenterWrapper"><Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} /></div>
      ) : (
        <>{renderMainContent(themeName)}</>
      )}
    </>
  );
};

export default ECProductComponent;
